import { API_ROUTE_ADMIN_INVOICES } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { InvoiceOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const getInvoicesList = async () =>
  (await get<{ invoices: InvoiceOriginal[] }>(API_ROUTE_ADMIN_INVOICES, IS_NEW_BACKEND_API))
    .invoices
